import { jsPDF } from 'jspdf'

import { sliceCanvasToPageChunks } from './pdfCapture.helper'

// Matches the top/bottom margin the existing Puppeteer-rendered offer summary uses
// (page.pdf({ format: 'A4', margin: { top: 50, bottom: 50 } }) in offer.service.ts),
// applied to all four sides so captured content isn't flush against the page edge.
const PAGE_MARGIN_PT = 50

// Assembles one canvas per captured tab into a single multi-page PDF, slicing any canvas
// taller than one page into consecutive pages so long tab content (e.g. History) doesn't
// get squashed onto a single oversized page.
export const createPdfFromCapturedTabs = (tabCanvases) => {
  const pdf = new jsPDF({ unit: 'pt', format: 'a4' })
  const pageWidthPt = pdf.internal.pageSize.getWidth()
  const pageHeightPt = pdf.internal.pageSize.getHeight()
  const contentWidthPt = pageWidthPt - PAGE_MARGIN_PT * 2
  const contentHeightPt = pageHeightPt - PAGE_MARGIN_PT * 2

  let hasAddedPage = false

  tabCanvases.forEach((canvas) => {
    const pageWidthPx = canvas.width
    const pageHeightPx = Math.round((contentHeightPt / contentWidthPt) * pageWidthPx)

    const pageChunks = sliceCanvasToPageChunks(canvas, { pageWidthPx, pageHeightPx })

    pageChunks.forEach((chunkCanvas) => {
      if (hasAddedPage) {
        pdf.addPage()
      }
      hasAddedPage = true

      const chunkHeightPt = (chunkCanvas.height / chunkCanvas.width) * contentWidthPt
      pdf.addImage(
        chunkCanvas.toDataURL('image/jpeg', 0.92),
        'JPEG',
        PAGE_MARGIN_PT,
        PAGE_MARGIN_PT,
        contentWidthPt,
        chunkHeightPt
      )
    })
  })

  return pdf.output('blob')
}
